export default "__VITE_ASSET__BCMON5MJ__"